import styled from 'styled-components'
import type { FC } from 'react'
import MapLayersPanel from '../../../pages/MapPage/components/MapLayersPanel'
import { StyledH4 } from '../../stylesNew'
import Close from '../../assets/icons/close.svg'

const Wrapper = styled.div`
  position: absolute;
  top: 1em;
  z-index: 9999;
  bottom: 10em;
  background: white;
  overflow: hidden;
  right: 1em;
  padding: 1em;
  width: 460px;
  max-width: calc(100% - 2em);
  display: flex;
  flex-direction: column;
  flex: 1;
`

const Content = styled.div`
  position: relative;
  overflow-y: scroll;
  width: 100%;
`

const Header = styled.div`
  border-bottom: 1px solid var(--greyMedium);
  padding-bottom: 0.5em;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;
`

export const CloseButton = styled.button`
  color: var(--light);
  background-color: var(--light);
  height: 1.5rem;
  width: 1.5rem;
  padding: 0;

  svg {
    width: 100%;
    height: 100%;
  }
  svg path {
    fill: var(--dark);
  }
`

const SidebarMapLegend: FC<{ onClose: () => void }> = ({ onClose }) => {
  return (
    <Wrapper>
      <Header>
        <StyledH4>Legenda</StyledH4>
        <CloseButton title="Sluit" type="button" onClick={onClose}>
          <Close />
        </CloseButton>
      </Header>
      <Content>
        <MapLayersPanel />
      </Content>
    </Wrapper>
  )
}

export default SidebarMapLegend
